module.exports = __webpack_public_path__ + "static/media/angel-capital-logo2.e771446c.png";